<div class="component-content-wrapper">
  @if (isSelectingAll) {
    <div class="select-all-overlay">
      <div class="select-all-overlay-content">
        <span class="select-all-overlay-message">Selecting all items... {{ selectedStockItemCount > 0 ? '(' + selectedStockItemCount + ' selected)' : '' }}</span>
      </div>
    </div>
  }
  @if (isModal) {
    <app-modal-header [title]="title" [close]="close"></app-modal-header>
  }
  <div (click)="onHideRefinementsClick()" class="grid" [ngClass]="{ 'has-modal-heading': isModal }">
    <div class="search-or-preview">
      @if (preview) {
        <h1>
          Selected Items
        </h1>
      }

      <app-shared-custom-search
        [searchAll]="searchString"
        class="search-bar"
        [placeholder]="shelfTalkers ? 'Search ShelfTalkers': 'Search Stock Items'"
        (searchChange)="searchOnKeyUp($event)">
      </app-shared-custom-search>
      @if (shelfTalkers) {
        <div (click)="totalItems > 0 ? onPrintAllVisibleClick() : null" class="print-all-button-div">
          <app-icon-price-tags></app-icon-price-tags>
          <span> Print {{ getDisplayedCount() }}</span>
        </div>
      }
      @if (shelfTalkers) {
        <div (click)="onPrintOtherItemsClick()" class="print-all-button-div">
          <app-icon-printer-outline></app-icon-printer-outline>
          <span> Print Other Items </span>
        </div>
      }
      @if (shelfTalkers) {
        <div (click)="deleteAllPrinted()" class="delete-all-button-div">
          <app-icon-delete-outline></app-icon-delete-outline>
          <span> Delete All {{ showDeleteAllPrinted ? 'Printed' : '' }} </span>
        </div>
      }

      @if (shelfTalkers) {
        <div class="show-settings-buttons">
          <app-shared-custom-select
            (selectionChange)="onShelfTalkerSettingsClick($event)"
            [allowMultiple]="false"
            [maxSelections]="1"
            [placeholder]="'Select Layout'"
            [selected]="getSelectedLayout"
            [setOptions]="allLayouts"
            [showChips]="false">
          </app-shared-custom-select>
        </div>
      }
      @if (supplier !== '' && supplier !== undefined) {
        <div class="supplier-toggle-div">
          <span>Only Show Supplier {{ supplier }}</span>
          <app-switch-ui
            [ariaLabel]="'Only Show Supplier'"
            [checked]="applyFilter"
            (checkedChange)="onToggleSupplierOnlyClick($event)">
          </app-switch-ui>
        </div>
      }
      @if (showFilters && !isShelfTalkersModal) {
        <div class="show-refinements">
          <app-icon-filter-variant (click)="onShowRefinementsClick($event)"></app-icon-filter-variant>
        </div>
      }
      @if (isShelfTalkersModal) {
        <div class="show-refinements">
          <app-icon-filter-variant (click)="onShowRefinementsClick($event)"></app-icon-filter-variant>
        </div>
      }


    </div>


    <ag-grid-angular
      (gridReady)="onGridReady($event)"
      (paginationChanged)="onPaginationChanged()"
      [columnDefs]="gridColDefs"
      [columnTypes]="columnTypes"
      [loading]="isLoading"
      [defaultColDef]="generalColDefDefaults"
      [loadingOverlayComponent]="loadingOverlay"
      [gridOptions]="getGridOptions"
      [rowData]="stockItems"
      [theme]="'legacy'"
      class="ag-theme-custom">
    </ag-grid-angular>
    <div>
      @if (!preview && !showPaginationBar && !isNaN(totalItems)) {
        <div class="custom-pagination-bar">
          Page Size:
          <select (change)="onPageSizeChange($event)" [(ngModel)]="itemsPerPage">
            @for (size of pageSizeOptions; track $index) {
              <option [value]="size">{{ size }}</option>
            }
          </select>
          <span class="spacing-span"></span>
          <span>{{ currentTablePage === 1 ? currentTablePage : (currentTablePage - 1) * itemsPerPage }}
            to <b>{{ currentTablePage * itemsPerPage > totalItems ? totalItems : currentTablePage * itemsPerPage }}</b>
            of <b>{{ totalItems }}</b>
          </span>
          <span class="spacing-span"></span>
          <app-icon-page-first
            (click)="!isFirstPageDisabled() && onGoToFirstPageClick()"
            [ngClass]="{ 'disabled': isFirstPageDisabled() }"
            [tooltip]="'First Page'"
            class="pagination-buttons">
          </app-icon-page-first>
          <app-icon-chevron-left
            (click)="!isFirstPageDisabled() && prevPage()"
            [ngClass]="{ 'disabled': isFirstPageDisabled() }"
            [tooltip]="'Previous Page'"
            class="pagination-buttons">
          </app-icon-chevron-left>
          <span>Page: {{ currentTablePage }} of <b>{{ totalPages }}</b></span>
          <app-icon-chevron-right
            (click)="!isLastPageDisabled() && nextPage()"
            [ngClass]="{ 'disabled': isLastPageDisabled() }"
            [tooltip]="'Next Page'"
            class="pagination-buttons">
          </app-icon-chevron-right>
          <app-icon-page-last
            (click)="!isLastPageDisabled() && onGoToLastPageClick()"
            [ngClass]="{ 'disabled': isLastPageDisabled() }"
            [tooltip]="'Last Page'"
            class="pagination-buttons">
          </app-icon-page-last>
        </div>
      }

    </div>

    <div class="buttons-div">
      @if (shelfTalkers && exceptions) {
        <app-shared-button
          [disabled]="selectedStockItemCount < 1"
          class="add-exception-selected-button">
          <span (click)="onAddExceptionClick()">
            <app-icon-link-variant></app-icon-link-variant>
            Add Exception
          </span>
        </app-shared-button>
      }
      @if (shelfTalkers) {
        <app-shared-button
          [disabled]="selectedStockItemCount < 1"
          class="delete-selected-button">
          <span (click)="onViewSelectedClick()">
            <app-icon-delete-outline></app-icon-delete-outline>
            Delete Selected
          </span>
        </app-shared-button>
      }
      @if (!shelfTalkers && !isShelfTalkersModal && !hideViewSelected) {
        <app-shared-button
          [disabled]="selectedStockItemCount < 1 && !preview">
          <span (click)="onViewSelectedClick()">
            {{ getPreviewButtonData }}
          </span>
        </app-shared-button>
      }
      @if (!shelfTalkers && !isShelfTalkersModal) {
        @if (limitItems) {
          <app-shared-button
            [disabled]="selectedStockItemCount < 1"
            [fill]="false">
          <span (click)="onGetSelectedStockItemsClick()">
              <span>
                <ng-container>
                  Add {{ selectedStockItemCount !== 1 ? selectedStockItemCount + ' items' : selectedStockItemCount + ' item' }}
                </ng-container>
              </span>
          </span>
          </app-shared-button>
        } @else {
          <app-shared-button
            [disabled]="(selectedStockItemCount < 1 )"
            [fill]="false">
          <span (click)="onGetSelectedStockItemsClick()">
              <span>
                  Add {{ selectedStockItemCount !== 1 ? selectedStockItemCount + ' items' : selectedStockItemCount + ' item' }}
              </span>
          </span>
          </app-shared-button>
        }

      }

      @if (isShelfTalkersModal && !hideSelectAll) {
        <app-shared-button
          [disabled]="isSelectingAll || !totalItems"
          [fill]="false">
          <span (click)="onSelectAllClick()">
            @if (isSelectingAll) {
              Selecting...
            } @else {
              Select All
            }
          </span>
        </app-shared-button>
      }
      @if ((shelfTalkers || isShelfTalkersModal) && !hideSelectAll) {
        <app-shared-button
          [disabled]="selectedStockItemCount < 1"
          [fill]="false">
          <span (click)="deselectAll()">
            Unselect All
          </span>
        </app-shared-button>
      }
      @if (shelfTalkers || isShelfTalkersModal) {
        <app-shared-button
          [disabled]="selectedStockItemCount < 1"
          [fill]="false"
          class="print-shelftalkers-button">
          <span (click)="onGetSelectedStockItemsClick()">
            @if (confirmButtonLabel) {
              {{ confirmButtonLabel }} {{ selectedStockItemCount > 0 ? '(' + selectedStockItemCount + ')' : '' }}
            } @else {
              Print {{ selectedStockItemCount !== 1 ? selectedStockItemCount + ' ShelfTalkers' : selectedStockItemCount + ' ShelfTalker' }}
            }
          </span>
        </app-shared-button>
      }

    </div>

  </div>

  @if (showFilters && !isShelfTalkersModal) {
    <div [ngClass]="{
      'hide-refinements': !showRefinements,
      'display-refinements': showRefinements
    }">
      <app-stock-refinements
        (emitFilters)="onUpdateFilters($event)"
        [facetCounts]="facetCounts"
        [isStockManager]="false"
        [lineColours]="lineColours"
        [selectedDepartmentsAndSubDepartments]="departmentsObservable$ | ngrxPush"
        [selectedSuppliers]="suppliersObservable$ | ngrxPush"
      ></app-stock-refinements>
    </div>
  }
  @if (isShelfTalkersModal) {
    <div [ngClass]="{
      'hide-refinements': !showRefinements,
      'display-refinements': showRefinements
    }">
      <app-stock-refinements
        (emitFilters)="onUpdateFilters($event)"
        (emitFilterGroup)="onUpdateFilterGroup($event)"
        [advancedFilters]="advancedFiltersObservable$ | ngrxPush"
        [appliedAdvancedFilters]="selectedAdvancedFilter"
        [facetCounts]="facetCounts"
        [isStockManager]="false"
        [lineColours]="lineColours"
        [selectedDepartmentsAndSubDepartments]="departmentsObservable$ | ngrxPush"
        [selectedSuppliers]="suppliersObservable$ | ngrxPush"
      ></app-stock-refinements>
    </div>
  }

</div>

